<template>
  <div class="row offer-filter pad">
    <div class="col-md-12 padTop">
      <c-switch type="icon" variant="info" v-bind="{on: '\uf00c', off: '\uf00d'}" v-model="Storage.OldbyWmFilter" :disabled="disabled"/>
      {{ $t('filters.by_wm') }}
    </div>
  </div>
</template>

<script>
  import Storage from '../../api/Storage'
  import cSwitch from '../Switch'

  export default {
    name: 'OldWmFilter',
    components: {
      cSwitch
    },
    props: {
      disabled: {
        type: Boolean,
        required: true
      }
    },
    data () {
      return {
        Storage: Storage
      }
    }
  }
</script>

<style>
 .padTop{
    padding: 13px 20px;
 }
</style>



// WEBPACK FOOTER //
// OldWmFilter.vue?04627eed